<div class="asset-side-menu section dark">
  <div class="side-menu-header">
    <div class="header-toggle" [class.active]="mode === 'info'" (click)="mode !== 'info' && switchMode('info')">
      <span>Information</span><span class="hidden">Information</span>
    </div>
    <div
      class="header-toggle"
      [class.active]="mode === 'activity'"
      (click)="mode !== 'activity' && switchMode('activity')"
    >
      <span>Activity</span><span class="hidden">Activity</span>
    </div>
    <div class="spacer"></div>
    <app-context-menu [options]="{ width: '240px', noSpacing: true }" #assetContextMenu [position]="'right'">
      <button
        appButton
        name="options"
        location="asset-sidebar"
        [iconButton]="true"
        height="1"
        color="simple-gray"
        appTooltip="More options"
        contextButton
        data-test-id="asset-sidebar-more"
      >
        <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
      </button>
      <div contextContent>
        <app-asset-context-menu
          [asset]="asset"
          [gallery]="gallery"
          [clientMode]="clientMode"
          [assetPageMode]="true"
          [thumbnailsShown]="thumbnailBarOpen"
          [accessLevel]="accessLevel"
          (onClose)="assetContextMenu.close()"
          (onToggleThumbnails)="onThumbnailBarOpen.emit($event)"
          (openShare)="openShareDialog()"
          (onDelete)="onDeleteAsset()"
          (onNewVersion)="onUpload.emit()"
          *ngIf="assetContextMenu.isOpen"
        >
        </app-asset-context-menu>
      </div>
    </app-context-menu>

    <button appButton name="close" location="asset-sidebar" [iconButton]="true" (click)="close()" color="hard-simple">
      <app-svg src="/assets/icons/slide-right.svg"></app-svg>
    </button>
  </div>

  <ng-content></ng-content>
</div>
